import { Dialog, DialogHeading } from 'omakase';
import BusinessPlaylistsDialogNewListPage from 'components/profile/playlists/BusinessPlaylistsDialogListPage';

interface Props {
  isOpen: boolean;
  onClose(): void;
}

const CreatePlaylistDialog: React.FunctionComponent<Props> = ({ isOpen, onClose }) => {
  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogHeading onClose={onClose}>New List</DialogHeading>
      <BusinessPlaylistsDialogNewListPage onSaveDone={onClose} />
    </Dialog>
  );
};

export default CreatePlaylistDialog;
